import { Navigate, useLocation } from "react-router-dom";
import React from "react";

const ProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation();

  // Get user info from localStorage
  const userStr = localStorage.getItem("user");
  const user = userStr ? JSON.parse(userStr) : null;

  // Check if user is authenticated and has required role
  const isAuthenticated = !!user;
  const hasRequiredRole = user && allowedRoles.includes(user.UserRole);
  /*
  console.log("user:", userStr);
  console.log("isAuthenticated:", isAuthenticated);
  console.log("hasRequiredRole:", hasRequiredRole);
  console.log("Roles:", user.UserRole);
  */
  if (!isAuthenticated) {
    // Redirect to login if not authenticated
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (!hasRequiredRole) {
    // Redirect to unauthorized page if authenticated but doesn't have required role
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return children;
};

export default ProtectedRoute;
